// Разбор VTK legacy BINARY POLYDATA, который пишет сервис сегментации (tjb-seg, imaging/vtkio.py).
//
// Формат: текстовый заголовок, затем
//   POINTS N float          + N*3 чисел float32 (big-endian)
//   POLYGONS M 4*M          + M*4 чисел int32 (3, a, b, c)
// Возвращает { positions: Float32Array, indices: Uint32Array }; ничего не знает про three.js,
// поэтому проверяется обычными тестами.

const ASCII = new TextDecoder('ascii');

// Читает строку (до \n) начиная с offset. Возвращает [текст, смещение следующей строки].
const readLine = (bytes, offset) => {
  let end = offset;
  while (end < bytes.length && bytes[end] !== 10) end += 1;
  return [ASCII.decode(bytes.subarray(offset, end)).trim(), end + 1];
};

export const parseVtkPolyData = (buffer) => {
  const bytes = new Uint8Array(buffer);
  const view = new DataView(buffer);
  let pos = 0;
  let line;

  [line, pos] = readLine(bytes, pos);
  if (!line.startsWith('# vtk DataFile')) throw new Error('Это не файл VTK');
  [, pos] = readLine(bytes, pos);               // заголовок
  [line, pos] = readLine(bytes, pos);
  if (line !== 'BINARY') throw new Error('Поддерживается только бинарный VTK');
  [line, pos] = readLine(bytes, pos);
  if (line !== 'DATASET POLYDATA') throw new Error('Ожидался DATASET POLYDATA');

  let positions = null;
  let indices = null;
  while (pos < bytes.length) {
    [line, pos] = readLine(bytes, pos);
    if (!line) continue;
    const parts = line.split(/\s+/);
    if (parts[0] === 'POINTS') {
      const n = parseInt(parts[1], 10);
      if (parts[2] !== 'float') throw new Error('Ожидались координаты float');
      positions = new Float32Array(n * 3);
      for (let i = 0; i < n * 3; i += 1) positions[i] = view.getFloat32(pos + i * 4, false);
      pos += n * 12;
    } else if (parts[0] === 'POLYGONS') {
      const m = parseInt(parts[1], 10);
      const total = parseInt(parts[2], 10);
      if (total !== m * 4) throw new Error('Поддерживаются только треугольники');
      indices = new Uint32Array(m * 3);
      for (let i = 0; i < m; i += 1) {
        const base = pos + i * 16;
        if (view.getInt32(base, false) !== 3) throw new Error('Поддерживаются только треугольники');
        indices[i * 3] = view.getInt32(base + 4, false);
        indices[i * 3 + 1] = view.getInt32(base + 8, false);
        indices[i * 3 + 2] = view.getInt32(base + 12, false);
      }
      pos += m * 16;
    }
  }
  if (!positions || !indices) throw new Error('В файле нет вершин или граней');
  return { positions, indices };
};
